module.exports.degree = require('./src/degree.js');
module.exports.betweenness = require('./src/betweenness.js');
